<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h3>Bidding</h3>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content" id="bidPage">
    	<div class="col-sm-12">
    		<div class="row">
    			<div class="col-sm-2">
						<p class="h1">{{lotDetails.name}} &nbsp;</p>
					</div>
					<div class="col-sm-5 d-flex align-items-center">
						<div class="col-sm-6">
							<button class="btn btn-secondary" @click="goBack">Back to Auction Page</button>
						</div>
					</div>
					<div class="col-sm-5 d-flex align-items-left" id="cdownDiv">
						<h1 id="hdenH" hidden style="color: red;">Bidding ends in: </h1> <h1 id="cdown" style="color: red;" hidden> 5</h1>
					</div>
				</div>
			</div>
			<div class="col-sm-12">
				<div class="row">
					<div class="col-sm-8">
						<div class="card card-primary card-outline">
							<div class="card-body">
								<splide>
  <splide-slide>
    <img :src="lotDetails.image_url" alt="Lot Image" style="max-width: 100%; height: 75%;">
  </splide-slide>
  <splide-slide>
  	<div class="overflow-auto">
    <datatable style="margin-top:1%; margin-left:1%; margin-right:1%; margin-bottom:1%;" :columns="columns">
      	<tbody>
        	<tr>
          		<td>{{row[0].row_name}}</td>
				<td>
					{{r1c1p}}
				</td>
				<td>
					{{r1c2p}}
				</td>
				<td>
					{{r1c3p}}
				</td>
				<td v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
					{{r1c4p}}
				</td>
				<td>
					<b>{{totalr1p}}</b>
				</td>
          	</tr>
			  <tr v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
          		<td>{{row[1].row_name}}</td>
				<td>
					{{r2c1p}}
				</td>
				<td>
					{{r2c2p}}
				</td>
				<td>
					{{r2c3p}}
				</td>
				<td>
					{{r2c4p}}
				</td>
				<td>
					<b>{{totalr2p}}</b>
				</td>
          	</tr>
			  <tr v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
          		<td>{{row[2].row_name}}</td>
				<td>
					{{r3c1p}}
				<td>
					{{r3c2p}}
				</td>
				<td>
					{{r3c3p}}
				</td>
				<td>
					{{r3c4p}}
				</td>
				<td>
					<b>{{totalr3p}}</b>
				</td>
          	</tr>	
			  <tr>
          		<th>Total %</th>
				<td>
					<b>{{totalc1p}}</b>
				</td>
				<td>
					<b>{{totalc2p}}</b>
				</td>
				<td>
					<b>{{totalc3p}}</b>
				</td>
				<td v-if="lotDetails.subtype != 'Seed' && lotDetails.subtype != 'Pan'">
					<b>{{totalc4p}}</b>
				</td>
				<td>
					<b>{{totalp}}</b>
				</td>
          	</tr>			
        </tbody>
      </datatable>
      </div>
  </splide-slide>
  <splide-slide>
  	<table class="table table-striped table-hover">
				<tbody>
  <tr>
    <td><b>Liter Weight: </b></td>
    <td>{{lotDetails.liter_weight}}</td>
  </tr>
  <tr>
    <td><b>Net Weight: </b></td>
    <td>{{lotDetails.net_weight}}</td>
  </tr>
  <tr>
    <td><b>Color: </b></td>
    <td>{{lotDetails.color}}</td>
  </tr>
  <tr>
    <td><b>Moisture Content: </b></td>
    <td>{{lotDetails.moisture_content}}</td>
  </tr>
  <tr>
    <td><b>Clean Lot: </b></td>
    <td v-if="lotDetails.clean_lot == 1">Yes</td>
    <td v-else>No</td>
  </tr>
  <tr>
    <td><b>Quote Price: </b></td>
    <td>{{lotDetails.quote_price}}</td>
  </tr>
  <tr>
    <td><b>Discount: </b></td>
    <td>{{lotDetails.discount}}</td>
  </tr>
  </tbody>
</table>	
  </splide-slide>
</splide>
							</div>
						</div>
					</div>
					<div class="col-sm-4">
						<div class="card card-primary card-outline">
							<div class="card-body">
								<span><b>My Bid</b></span>
								<div class="form-group">
									<input type="number" class="form-control" pattern="[0-9]" v-model="my_bid" placeholder="Enter your bid" min="1">
								</div>
								<div class="form-group">
									<label>Increment for Instant Out Bid Amount</label>
									<input class="form-control" type="number" pattern="[0-9]" placeholder="Increment" v-model="increment">
								</div>
								<button class="btn btn-dark" @click="bid" id="bidBtn"><b>BID NOW</b></button>
								<button class="btn btn-success" @click="autoModal"><b>View Auto Bid</b></button>
							</div>
						</div>
						<div class="row">
							<div class="col-md-6 col-sm-6">
								<div class="card card-primary card-outline">
									<!-- <div class="card-header">Seller</div> -->
									<div class="card-body">
										<b>Seller</b>
										<h3 v-if="lot.seller != 'Anonymous'"><a href="#" @click="sellerModal()">{{lot.seller}}</a></h3>
										<h3 v-else>{{lot.seller}}</h3>
										</div>
								</div>
							</div>
							<div class="col-md-6 col-sm-6">
								<div class="card card-primary card-outline">
									<!-- <div class="card-header">Highest Bid</div> -->
									<div class="card-body bg-success" v-if="is_my_bid == 'true'">
										<b>Highest Bid</b>
										<h3>{{highest_bid_price}}</h3>
										<span class="badge badge-success" v-if="is_my_bid == 'true'">Your Bid</span>
									</div>
									<div class="card-body" v-else>
										<b>Highest Bid</b>
										<h3>{{highest_bid_price}}</h3>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 col-sm-6">
							<button class="btn btn-secondary" @click="history"><i class="fa fa-history"></i>Bid History</button>
						</div>
						
					</div>
				</div>
			</div>
<!-- row end -->
    </section>
    
<div class="modal" tabindex="-1" role="dialog" id="autoModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Lot Auto Bid</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<input type="number" pattern="[0-9]" placeholder="Enter starting price" class="form-control" v-model="form.starting_quote_price" min="1">
		  <br>
      	<input type="number" pattern="[0-9]" placeholder="Enter maximum price" class="form-control" v-model="form.upper_quote_price" min="1">
		  <br>
      	<input type="number" pattern="[0-9]" placeholder="Enter increment" class="form-control" v-model="form.increment" min="1">
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      	<button class="btn btn-primary" @click="setAutoBid">Set</button>
      </div>
    </div>
	</div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="sellerModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Seller Details</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      	<b>Phone: </b>{{seller_phone}}<br>
      	<b>E-mail: </b>{{seller_email}}<br>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
	</div>
</div>
<div class="modal" tabindex="-1" role="dialog" id="overModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
      	<h1>{{content}}</h1>
      </div>
      <div class="modal-footer">
      	<button class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
	</div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="history">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">Bidding History</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">
						<p v-for="(data,index) in bids_history.slice().reverse()" :key="index"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>  <span style="color: #1fa67a">{{data.bid_price}}</span> was raised.</p>
					</div>
					<div class="card-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>
    <!-- /.content -->

<br>
      <br>
    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
   //import Echo from 'laravel-echo';
    //import SocketClient from 'socket.io-client';
    export default {
        mounted() {
            console.log('Component mounted.');
            window.Echo.channel('auction.newbid')
        		.listen('NewBid', (e) => {
        			if(e.highest.auction_lot_id == this.$route.params.id){
        				axios.post("/api/getAuctionLot", {id: this.$route.params.id})
        				.then(response => {
        					//this.lot_data = response.data;
        					this.lot = response.data;
        					this.highest_bid_price = this.lot.highest_bid_price;
        					if(this.lot.buyer_id == this.$userId){
        						this.is_my_bid = 'true';
        					}
        					else
        						this.is_my_bid = 'false';
        					this.my_bid = parseFloat(this.lot.highest_bid_price) + parseFloat(this.increment);
        					document.getElementById('hdenH').hidden = true;
        					document.getElementById('cdown').hidden = true;
        				})
        				//this.lot_data = e.highest;
        				//this.highest_bid_price = e.highest.bid_price;
        				//this.bid_status.push({bid_price: e.highest.bid_price});
        				/*if(e.highest.buyer_id == this.$userId){
        					this.is_my_bid = 'true';
        				}
        				else
        					this.is_my_bid = 'false';*/
        				//this.my_bid = parseFloat(e.highest.bid_price) + parseFloat(this.increment);
        				//document.getElementById('hdenH').hidden = true;
        				//document.getElementById('cdown').hidden = true;
        				
        			}
        		});
        		
        		window.Echo.channel('auction.fives')
        		.listen('Fives', (e) => {
        			if(e.id == this.$route.params.id){
        				document.getElementById('hdenH').hidden = false;
        				document.getElementById('cdown').hidden = false;
        				this.startTicking();
        			}
        		});
        		
        		window.Echo.channel('auction.status-change')
        		.listen('StatusChange', (e) => {
        				
        				if(e.status == 'sold' && e.auction_lot_id == this.$route.params.id){
        					if(e.buyer == this.$userId){
        						this.content = 'You won lot: '+e.lot_name;
        					}
        					else
        						this.content = 'Lot: ' + e.lot_name +' Sold';
        				}
        				else if(e.status == 'withdrawn' && e.auction_lot_id == this.$route.params.id){
        					this.content = 'Lot: ' + e.lot_name + ' Withdrawn'
        				}
        				
        				$("#overModal").modal('show');
        				
        				//this.getNextLot();
        		});
        		
        		document.getElementById("bidPage")
    				.addEventListener("keyup", function(event) {
    					console.log("bid");
    					event.preventDefault();
    					if (event.keyCode === 13) {
        				document.getElementById("bidBtn").click();
   						 }
						});
        },
        components: {datatable:Datatable, pagination:Pagination},
        created(){
        	this.getLot();
        	//this.getQualities();
        	this.getBids();
        },
        
        data(){
        	let sortOrders = {};
        	return {
        	columns: [
				  {width:'10%', label:"Grade/Quality", name:'value_mg'},

				  ],
				  sortKey: 'id',
        		sortOrders: sortOrders,
				options: {
			  	rewind : true,
				  width  : 800,
				  perPage: 1,
				  gap    : '1rem',
			  },
        		my_bid: '',
        		//lot_data: [],
        		lot: {},
        		highest_bid_price: '',
        		lotDetails: [],
        		row: [],
        		qualities: [],
        		is_my_bid: '',
        		form: new Form({
         			starting_quote_price: '',
         			upper_quote_price: '',
         			increment: 1,
         			buyer_id: this.$userId,
         			auction_lot_id: '',
         			id: ''
         		}),
         		r1c1p: '',
				r1c2p: '',
				r1c3p: '',
				r1c4p: '',
				r2c1p: '',
				r2c2p: '',
				r2c3p: '',
				r2c4p: '',
				r3c1p: '',
				r3c2p: '',
				r3c3p: '',
				r3c4p: '',
				totalc1p: '',
				totalc2p: '',
				totalc3p: '',
				totalc4p: '',
				totalr1p: '',
				totalr2p: '',
				totalr3p: '',
				totalp: '',
				increment: 2,
				seller_phone: '',
				seller_email: '',
				content: '',
				bids_history: []
        	}
        	
        },
        
        methods: {
        	bid(){
        		if(this.my_bid >= this.lot.quote_price && (this.lot.length == 0 || this.my_bid > this.lot.highest_bid_price)){
        			var d = new Date();
							var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
							var nd = new Date(utc + (3600000*+5.5));
        			axios.post("/api/postBid", {
        				auction_lot_id: this.$route.params.id,
        				auction: this.lot.auction_id,
        				buyer_id: this.$userId,
        				bid_price: this.my_bid,
        				bidding_mode: "Manual",
        				bid_time: nd.toLocaleTimeString()
        			})
        			.then(response => {
        				if(response.data == '400'){
        					toast.fire({
      	      			type: 'error',
              			title: 'Bidding Not Active For This Lot'
            			});
        				}
        				else if(response.data == "500")
        					toast.fire({
      	      			type: 'error',
              			title: 'Bid Rejected. Increase bid or wait to be out bidded'
            			});
            		else
            			toast.fire({
      	      			type: 'success',
              			title: 'Bid Placed'
            			});
        			})
        		}
        		else{
        			toast.fire({
      	      	type: 'error',
              	title: 'Make sure bid is greater than quote price or highest bid'
            	});
        		}
        	},
        	
        	getLot(){
        		axios.post("/api/getAuctionLot", {id: this.$route.params.id})
        		.then(response => {
        			this.lot = response.data;
        			this.highest_bid_price = this.lot.highest_bid_price;
        			this.getLotDetails();
        		})
        	},
        	
        	autoModal(){
        		axios.post("/api/getAutoBid", {id: this.$route.params.id, buyer_id: this.$userId})
       			.then(response => {
       				this.form.fill(response.data);
       				$("#autoModal").modal("show");
       			})
       		},
       		
       		goBack(){
       			window.history.back();
       		},
       		
       		getLotDetails(){
       			axios.post("/api/getLotDetails", {id: this.lot.lot_id, customer: true})
       			.then(response => {
       				this.lotDetails = response.data;
       				this.getQualities();
       				this.getTemplate();
       				this.getLotGrades();
       			})
       		},
       		
       		getLotGrades(){
       			//this.form.lot_id = this.$route.params.id;
       			axios.post("/api/getLotGrades", {id: this.lotDetails.id})
       			.then(response => {
       				if(response.data != null){
								this.r1c1p = parseFloat(response.data[0].value_percentage).toPrecision(3);
								this.r1c2p = parseFloat(response.data[1].value_percentage).toPrecision(3);
								this.r1c3p = parseFloat(response.data[2].value_percentage).toPrecision(3);
								if(this.lotDetails.subtype != 'Seed' && this.form.subtype != 'Pan'){
							this.r1c4p = parseFloat(response.data[3].value_percentage).toPrecision(3);
							this.r2c1p = parseFloat(response.data[4].value_percentage).toPrecision(3);
							this.r2c2p = parseFloat(response.data[5].value_percentage).toPrecision(3);
							this.r2c3p = parseFloat(response.data[6].value_percentage).toPrecision(3);
							this.r2c4p = parseFloat(response.data[7].value_percentage).toPrecision(3);
							this.r3c1p = parseFloat(response.data[8].value_percentage).toPrecision(3);
							this.r3c2p = parseFloat(response.data[9].value_percentage).toPrecision(3);
							this.r3c3p = parseFloat(response.data[10].value_percentage).toPrecision(3);
							this.r3c4p = parseFloat(response.data[11].value_percentage).toPrecision(3);   
							this.calculatePercentage();
						}
						else{
							this.calculateSeed();
						}  
							}
       			})
       		}, 
       		
       		calculatePercentage(){
				   	this.totalc1p = (parseFloat(this.r1c1p)+parseFloat(this.r2c1p)+parseFloat(this.r3c1p)).toPrecision(4);
						this.totalc2p = (parseFloat(this.r1c2p)+parseFloat(this.r2c2p)+parseFloat(this.r3c2p)).toPrecision(4);
						this.totalc3p = (parseFloat(this.r1c3p)+parseFloat(this.r2c3p)+parseFloat(this.r3c3p)).toPrecision(4);
						this.totalc4p = (parseFloat(this.r1c4p)+parseFloat(this.r2c4p)+parseFloat(this.r3c4p)).toPrecision(4);
						this.totalr1p = (parseFloat(this.r1c1p)+parseFloat(this.r1c2p)+parseFloat(this.r1c3p)+parseFloat(this.r1c4p)).toPrecision(4);
						this.totalr2p = (parseFloat(this.r2c1p)+parseFloat(this.r2c2p)+parseFloat(this.r2c3p)+parseFloat(this.r2c4p)).toPrecision(4);
						this.totalr3p = (parseFloat(this.r3c1p)+parseFloat(this.r3c2p)+parseFloat(this.r3c3p)+parseFloat(this.r3c4p)).toPrecision(4);
						this.totalp = (parseFloat(this.totalc1p)+parseFloat(this.totalc2p)+parseFloat(this.totalc3p)+parseFloat(this.totalc4p)).toPrecision(3);
       		},
       		
       		calculateSeed(){
       			this.totalc1p = (parseFloat(this.r1c1p)).toPrecision(4);
						this.totalc2p = (parseFloat(this.r1c2p)).toPrecision(4);
						this.totalc3p = (parseFloat(this.r1c3p)).toPrecision(4);
						this.totalr1p = (parseFloat(this.r1c1p)+parseFloat(this.r1c2p)+parseFloat(this.r1c3p)).toPrecision(4);
						this.totalp = (parseFloat(this.totalc1p)+parseFloat(this.totalc2p)+parseFloat(this.totalc3p)).toPrecision(3);
       		},
       		
       		getTemplate(){
       			axios.post("/api/getTemplates", {type: this.lotDetails.subtype})
        		.then(response => {
							this.row = response.data;
        		})
					},
					
					getQualities(url="/api/getQualities"){
       			axios.post(url, {subtype: this.lotDetails.subtype})
       			.then(response => {
       				this.qualities = response.data;
					   //this.configPagination(response.data.data);
					for(var i=0; i<this.qualities.length;i++){
						this.columns.push(
							{width: '10%', label: this.qualities[i].name, name: this.qualities[i].name}
						);
					}
					this.columns.push(
							{width: '10%', label: "Total %", name: "total"}
						);
       			})
       		},
			
				sellerModal(){
					axios.post("/api/getSeller", {id: this.lotDetails.seller_id})
					.then(response => {
						this.seller_phone = response.data.mobile;
						this.seller_email = response.data.email;
						$("#sellerModal").modal("show");
					})
				},
				
				getBids(){
					axios.post("/api/showBids", {id: this.$route.params.id})
					.then(response => {
						for(var i = 0; i<response.data.length;i++){
							if(response.data[i].status == 'Bid' && response.data[i].buyer_id == this.$userId){
								this.is_my_bid = 'true';
							}
						}
					})
				},
				
				setAutoBid(){
					this.form.auction_lot_id = this.$route.params.id;
					this.form.buyer_id = this.$userId;
       		this.form.post("/api/setAutoBid")
       		.then(() => {
       			toast.fire({
       				type: "success",
       				title: "Auto Bid Set"
       			})
       		})
       		.catch(() => {
       			toast.fire({
       				type: "error",
       				title: "Failed"
       			})
       		})
       	},
       	
       	startTicking(){
       		var timeleft = 10;
       		document.getElementById('hdenH').innerHTML = "Bidding Ends in: ";
					var downloadTimer = setInterval(function(){
  					if(timeleft <= 0){
  						document.getElementById('hdenH').innerHTML = "BIDDING OVER!";
  						document.getElementById("cdown").innerHTML = "";
    					clearInterval(downloadTimer);
  					}
  					document.getElementById("cdown").innerHTML = timeleft;
  					timeleft -= 1;
					}, 1000);
       	},
       	
       	getNextLot(){
       		axios.post("/api/showCurrAuctionLot")
       		.then(response => {
       			this.$router.replace('/home/buyer/lot-bidding/'+response.data.id);
       			location.reload();
       		})
       	},
       	
       	history(){
       			axios.post("/api/showBids", {id:  this.$route.params.id})
       			.then(response => {
       				this.bids_history = response.data;
       				$('#history').modal('show');
       			})
       		}
			}  
        }
</script>
